<template>
    <div>
        <label v-if="label" :for="id" v-html="label"></label>
        <div class="input-group">
            <div class="col-3 px-0">
                <input-select
                    name="bdo-day"
                    :select-list-default="daysSelection"
                    :value="daySelected"
                    @input="daySelected = $event"
                ></input-select>
            </div>
            <div class="col-6 px-0">
                <input-select
                    name="bdo-month"
                    :select-list-default="monthsSelection"
                    :value="monthSelected"
                    @input="monthSelected = $event"
                ></input-select>
            </div>
            <div class="col-3 px-0">
                <input-select
                    name="bdo-year"
                    :select-list-default="yearsSelection"
                    :value="yearSelected"
                    @input="yearSelected = $event"
                ></input-select>
            </div>
            <input type="hidden" :name="name" :value="inputValue" />
        </div>
        <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0 -translate-y-2"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 -translate-y-2"
        >
            <div
                v-if="error"
                class="mt-2 px-1 flex items-center gap-2 text-red-500"
            >
                <i class="fa fa-exclamation-triangle text-[11px]"></i>
                <span
                    class="text-[11px] font-bold uppercase tracking-wider"
                    v-html="error"
                ></span>
            </div>
        </transition>
    </div>
</template>

<script>
import mixinCommon from "./mixinCommon.vue";
import mixinInput from "./mixinInput.vue";

import moment from "moment";

import Input from "./Input.vue";

const { props } = Input;

export default {
    mixins: [mixinCommon, mixinInput],

    components: {
        "input-child": Input,
    },
    props: {
        ...props,
        lang: {
            type: String,
            default: "en",
        },
    },
    computed: {
        date: {
            get() {
                return new Date(this.inputValue);
            },
            set(date) {
                this.inputValue = moment(date).format("YYYY-MM-DD");
            },
        },
    },
    watch: {
        daySelected: function (newData, oldData) {
            if (newData != oldData) {
                this.updateDate();
            }
        },
        monthSelected: function (newData, oldData) {
            if (newData != oldData) {
                this.setDaysSelection(newData, this.yearSelected);
                this.updateDate();
            }
        },
        yearSelected: function (newData, oldData) {
            if (newData != oldData) {
                this.setDaysSelection(this.monthSelected, newData);
                this.updateDate();
            }
        },
    },

    data() {
        return {
            daySelected: null,
            daysSelection: [],
            monthSelected: null,
            monthsSelection: [],
            yearSelected: null,
            yearsSelection: [],
        };
    },
    mounted() {
        if (this.value) {
            let datemoment = moment(this.value);
            this.daySelected = datemoment.format("DD");
            this.monthSelected = datemoment.format("M");
            this.yearSelected = datemoment.format("YYYY");
            this.setDaysSelection(this.monthSelected, this.yearSelected);
        } else {
            // Initialize empty selection lists even if no date is selected
            this.setDaysSelection(null, null); // Or pass defaults if needed for length
        }

        let tmpDate = moment().locale(this.lang).startOf("year");
        for (let i = 1; i <= 12; i++) {
            this.monthsSelection.push({
                value: tmpDate.format("M"),
                text: tmpDate.format("MMMM"),
            });
            tmpDate.add(1, "M");
        }
        for (let i = moment().format("YYYY"); i > 1900; i--) {
            this.yearsSelection.push({ value: i, text: i });
        }
    },
    methods: {
        updateDate() {
            if (this.yearSelected && this.monthSelected && this.daySelected) {
                let datemoment = moment();
                datemoment.startOf("day"); // clear time
                datemoment.year(this.yearSelected);
                datemoment.month(this.monthSelected - 1);
                datemoment.date(this.daySelected);
                this.inputValue = datemoment.format("YYYY-MM-DD");
            } else {
                this.inputValue = "";
            }
        },

        setDaysSelection(month, year) {
            this.daysSelection = [];

            // Default to 31 days if no month/year selected yet, to allow user to pick day first if they want
            let daysInMonth = 31;

            if (month && year) {
                let date = moment()
                    .year(year)
                    .month(month - 1)
                    .startOf("month");
                daysInMonth = date.daysInMonth();
            } else if (month) {
                // If only month is selected, assume leap year or standard year? Default 31 is safest for UI.
                // Or use current year as reference.
                let date = moment()
                    .month(month - 1)
                    .startOf("month");
                daysInMonth = date.daysInMonth();
            }

            for (let i = 1; i <= daysInMonth; i++) {
                // Pad with leading zero
                let val = i < 10 ? "0" + i : "" + i;
                this.daysSelection.push({
                    value: val,
                    text: val,
                });
            }
        },
    },
};
</script>
